import { render, staticRenderFns } from "./UpdatePackageGrossMass.vue?vue&type=template&id=db89a9c8&"
import script from "./UpdatePackageGrossMass.vue?vue&type=script&lang=js&"
export * from "./UpdatePackageGrossMass.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePackageGrossMass.vue?vue&type=style&index=0&id=db89a9c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports